import { gql } from '@apollo/client';

const CLIENT_DETAIL_ADJUSTMENT_TASK_FIELDS = `
  id
  billId
  submitterName
  orderCount
  successCount
  failCount
  parseStatus
  failureReason
  resultFileUrl
  createdAt
  completedAt
`;

export const GET_CLIENT_DETAIL_ADJUSTMENT_TASKS = gql`
  query GetClientDetailAdjustmentTasks($billId: ID!) {
    getClientDetailAdjustmentTasks(billId: $billId) {
      ${CLIENT_DETAIL_ADJUSTMENT_TASK_FIELDS}
    }
  }
`;

export const GET_CLIENT_DETAIL_ADJUSTMENT_RESULT_DOWNLOAD_URL = gql`
  query GetClientDetailAdjustmentResultDownloadUrl($taskId: ID!) {
    getClientDetailAdjustmentResultDownloadUrl(taskId: $taskId)
  }
`;

export interface ClientDetailAdjustmentTaskType {
  id: string;
  billId: string;
  submitterName: string;
  orderCount: number;
  successCount: number;
  failCount: number;
  parseStatus: string;
  failureReason?: string | null;
  resultFileUrl?: string | null;
  createdAt: string;
  completedAt?: string | null;
}

export interface GetClientDetailAdjustmentTasksResponse {
  getClientDetailAdjustmentTasks: ClientDetailAdjustmentTaskType[];
}
